
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Vue from 'vue';
Vue.use(Loading);

const Application = {
    getOptions() {
        return axios.get(window.optionsUrl);
    },
    getLoader(color, canCancel) {
        return window.Vue.$loading.show({
            color: color,
            canCancel: canCancel,
            onCancel: () => {},
        });
    }
};

export { Application };


// WEBPACK FOOTER //
// ./resources/assets/js/services/Application.js